import { render, staticRenderFns } from "./CekiDetay.vue?vue&type=template&id=0b122e3b"
import script from "./CekiDetay.vue?vue&type=script&lang=js"
export * from "./CekiDetay.vue?vue&type=script&lang=js"
import style0 from "./CekiDetay.vue?vue&type=style&index=0&id=0b122e3b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports